/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneAddCustomAction/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import CheckSelected from 'DesignSystem/Svgs/CheckSelected/index'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneAddCustomAction({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/TysiaSelectOneAddCustomAction",
  size,
  disabled,
  onlyForHoverFixMeInTheMorpherThanks,
  onClick,
  alignSelf,
  isSelected,
  text = "Option",
  textAlign
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
  let isMedia = useIsMedia()
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaSelectOneAddCustomAction.Horizontal"
  data-view-path={viewPath}
 style={{'--h-1-Z8FeyL': size === "small" ? "30px" : "40px"}}
 className={`views-block ${styles.Horizontal}`}
>
<button
  data-testid="TysiaSelectOneAddCustomAction.Horizontal:1"
  data-view-path={viewPath}
 disabled={disabled}
 {...isHoveredBind}
 onClick={onlyForHoverFixMeInTheMorpherThanks}
 onMouseDown={onClick}
 style={{'--as-3-Z8FeyL': alignSelf,'--bc-2-Z8FeyL': isSelected ? dtColorsNeutral200 : isHovered ? dtColorsNeutral200 : "#ffffff",'--pb-4-Z8FeyL': size === "small" ? "2px" : "4px",'--pl-5-Z8FeyL': size === "small" ? "8px" : "16px",'--pr-6-Z8FeyL': size === "small" ? "8px" : "16px",'--pt-7-Z8FeyL': size === "small" ? "2px" : "4px"}}
 className={`views-block ${styles.Horizontal1}`}
>
<span
  data-testid="TysiaSelectOneAddCustomAction.Text"
  data-view-path={viewPath}
 style={{'--ta-8-Z8FeyL': textAlign,'--c-9-Z8FeyL': isSelected ? "rgb(0,188,112)" : "#606060",'--ws-10-Z8FeyL': isMedia.mobile ? "wrap" : "nowrap"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 marginTop={dtSpaceXxs}
 marginLeft={dtSpaceXs}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="ADD"
/>
)}
</TysiaTag>
<CheckSelected
  viewPath={`${viewPath}/CheckSelected`}
 opacity={isSelected && !disabled ? 1 : 0}
 width={size === "small" ? "12px" : "18px"}
 height={size === "small" ? "12px" : "18px"}
 marginLeft={size === "small" ? "8px" : "16px"}
/>
</button>
</div>
{children}
</React.Fragment>)
}